// extracted by mini-css-extract-plugin
export default {"global-nav":"styles_global-nav__DoVep","admin":"styles_admin__d9co2"};